enum FleetType {
    MIXED,
    ETGE_ONLY,
    E4C_ONLY,
}

export default FleetType;
